// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"9b086fbd","294":"25534bc5","418":"aaaee8f0","583":"6312e842"}[chunkId] + ".chunk.js";
};